import { lazy } from 'react';

export const UpdateToolPageLazy = lazy(() => import('./UpdateToolPage'));
